<template>
  <b-modal :id="id"
           centered
           header-bg-variant="danger"
           header-text-variant="light"
           title="Delete Confirmation"
           ok-variant="danger"
           ok-title="Delete"
           @ok="$emit('ok')"
           @cancel="$emit('cancel')">
    <slot name="content">
      <p> {{ deleteModalText }}</p>
    </slot>
  </b-modal>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'DeleteModal',
  props: {
    id: String,
    deleteModalText: String
  },
}
</script>

<style lang="scss" scoped>

</style>